//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "page-start-view",
    data() {
        return {
            saving: false,
            show: false,
            showErJiPicker: false,
            showSanJiPicker: false,
            severities: [],
            reasons: [],
            erJiNodes: [],
            sanJiNodes: [],
            erJiFenLei: '',
            sanJiFenLei: '',
            severity: [],
            reason: [],
            startHandleWorkOrderDto: {
                xyContent: ''
            },
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        },
    },
    methods: {
        onSaveStartHandle() {
            //开始处理
            this.startHandleWorkOrderDto.reason = JSON.stringify(this.reason);
            this.startHandleWorkOrderDto.severity = JSON.stringify(this.severity);
            this.startHandleWorkOrderDto.workOrderId = this.workOrderInfo.id;
            this.saving = true
            abp.ajax.post('/api/services/app/WorkOrder/MStartHandleWorkOrder', this.startHandleWorkOrderDto).then(res => {
                this.show = false;
                this.$emit('handleSuccess')
            }).finally(() => {
                this.saving = false;
            });
        },
        onErJiConfirm(value, index) {
            this.erJiFenLei = value.text;
            this.startHandleWorkOrderDto.erJiFenLei = value.id;
            console.log(value)

            this.sanJiNodes = [];
            this.sanJiFenLei = '';
            this.startHandleWorkOrderDto.sanJiFenLei = 0;

            value.sanjiNodes.forEach(item => {
                this.sanJiNodes.push({
                    text: item.title,
                    id: item.id
                })
            });

            this.showErJiPicker = false;
        },
        onSanJiConfirm(value, index) {
            this.sanJiFenLei = value.text;
            this.startHandleWorkOrderDto.sanJiFenLei = value.id;
            this.showSanJiPicker = false;
        },

        getSeverities() {
            abp.ajax.get('/api/services/app/Dictionary/GetDictionaryItems?dicitionaryName=' + '投诉严重程度分类').then(res => {
                this.severities = [];
                this.severities.push(...res.data.result);
            }).finally(() => {

            });
        },
        getReasons() {
            abp.ajax.get('/api/services/app/Dictionary/GetDictionaryItems?dicitionaryName=' + '重复投诉引发原因').then(res => {
                this.reasons = [];
                this.reasons.push(...res.data.result);
            }).finally(() => {

            });
        },

        getComplaintCategories(type) {
            const vm = this;
            abp.ajax.get('/api/services/app/Node/GetNodesByName?name=' + type).then(res => {
                vm.erJiNodes = [];
                // vm.nodes.push(...res.data.result.items[0].children);
                res.data.result.items[0].children.forEach(item => {
                    vm.erJiNodes.push({
                        text: item.title,
                        id: item.id,
                        sanjiNodes: item.children
                    })
                });
            }).finally(() => {

            });
        },

        onShowPopup() {
            if (this.workOrderInfo.workOrderType === 1) {
                this.getSeverities();
                this.getReasons();
                this.getComplaintCategories('投诉分类');
            } else if (this.workOrderInfo.workOrderType === 2) {
                this.getComplaintCategories('报修分类');
            } else if (this.workOrderInfo.workOrderType === 0) {
                this.getComplaintCategories('咨询分类');
            }
            this.startHandleWorkOrderDto = {};
            this.show = true;
        }
    },
    created() {

    }
}
